import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { Location } from 'models/locations';

const propTypes = {
  location: PropTypes.instanceOf(Location).isRequired,
};

const Address = ({ location }) => (
  <Fragment>
    <div className="text-size-14 wrap-ellipses">{location.address}</div>
    <div className="text-size-12 text-weight-light wrap-ellipses">{location.name}</div>
  </Fragment>
);

Address.propTypes = propTypes;
export default Address;
